<template>
    <div class="hello grid-center">
<!--        <h2 class="col-12">{{ msg }}</h2>-->
        <h2 class="col-12 text-danger">{{msg_warning}}</h2>
<!--        <h5 class="header col-12">ФИО кандидата:</h5>-->
<!--        <div class="person col-4_lg-4_md-4_sm-12_xs-12">-->

<!--            <div class="label">Фамилия</div>-->
<!--            <div class="value"><input type="text" :class="isFilledSurname" v-model="surname"></div>-->

<!--            <div class="label">Имя</div>-->
<!--            <div class="value"><input type="text" :class="isFilledName" v-model="name"></div>-->

<!--            <div class="label">Отчество</div>-->
<!--            <div class="value"><input type="text" :class="isFilledPatronymic" v-model="patronymic"></div>-->

<!--            <div class="label">Email</div>-->
<!--            <div class="value"><input type="email" v-model="email"></div>-->


<!--        </div>-->
<!--        <div class="col-12"></div>-->
<!--        <button :disabled="isDisabled" class="button" @click="createAssessment($event, spv)">ДМ, ЗДМ, АДМ</button>-->
<!--        <button :disabled="isDisabled" class="button" @click="createAssessment($event, noo)">СПВ (заполняет НОО)-->
<!--        </button>-->
<!--        <button :disabled="isDisabled" class="button" @click="createAssessment($event, rmp)">СПВ (заполняет РПМ)-->
<!--        </button>-->
    </div>
</template>

<script>
    export default {
        name: 'HelloWorld',

        props: {
            msg: String,
            msg_warning: String,
        },
        data() {
            return {
                spv: 'spv',
                noo: 'noo',
                rmp: 'rmp',
                surname: '',
                name: '',
                patronymic: '',
                email: ''
            }
        },
        computed: {
            isDisabled() {
                let result = false;
                if (this.name === '') {
                    result = true
                }
                if (this.surname === '') {
                    result = true
                }
                if (this.patronymic === '') {
                    result = true
                }
                return result
            }
        },
        methods: {
            createAssessment(event, value) {
                let payload = {
                    'type': value,
                    'name': this.name,
                    'family': this.surname,
                    'patron': this.patronymic,
                    'email': this.email
                };
                this.$store.dispatch('CREATE_ASSESSMENT', payload).then(
                    response => {
                        console.log('Hello response sucess: ', response);
                        this.$router.push({name: 'assessment', params: {sha256: response.sha256}});
                    }
                ).catch(
                    response => {
                        console.error('Hello response catch: ', response)
                    }
                )
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 10px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: white;
    }

    button {
        border: 1px solid #0066cc;
        background-color: #0099cc;
        color: #ffffff;
        padding: 5px 10px;
        margin: 5px;
    }

    button:hover {
        border: 1px solid #0099cc;
        background-color: #00aacc;
        color: #ffffff;
        padding: 5px 10px;
    }

    button:disabled,
    button[disabled] {
        border: 1px solid #999999;
        background-color: #cccccc;
        color: #666666;
    }

    .person {
        padding-top: 5px;
    }
    .value {
        margin-bottom: 10px;
    }

    .text-danger {
        color: tomato;
    }

</style>
